export const SET_SHIP_BY_DATE = 'set-ship-by-date';
export const SET_SHIP_BY_DAYS = 'set-ship-by-days';
export const MIN_DAYS_TO_ADD = 1;
export const DEFAULT_DAYS_TO_ADD = 1;
